/* LA' FORTE — legacy Freshworks/Freshchat storefront cleanup.
 * Freshdesk ticketing remains active; Shopify Inbox AI owns the storefront chat UI.
 */
(() => {
  const blockedSources = [
    'ind-widget.freshworks.com/widgets/82000003498.js',
    'la-forte-88a6e2174bfaf1816930654.freshchat.com/js/widget.js'
  ];

  const purgeLegacyChat = () => {
    document.querySelectorAll('script[src]').forEach((script) => {
      const src = script.getAttribute('src') || '';
      if (blockedSources.some((blocked) => src.includes(blocked))) script.remove();
    });

    document.querySelectorAll(
      '#fc_widget, iframe#fc_widget, [id^="freshworks-frame"], [class*="freshworks-widget"]'
    ).forEach((element) => element.remove());

    try {
      if (window.fcWidget && typeof window.fcWidget.destroy === 'function') {
        window.fcWidget.destroy();
      }
    } catch (_) {}
  };

  const start = () => {
    purgeLegacyChat();
    const observer = new MutationObserver(purgeLegacyChat);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('load', purgeLegacyChat, { once: true });
    setTimeout(purgeLegacyChat, 1000);
    setTimeout(purgeLegacyChat, 5000);
  };

  if (document.documentElement) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
